import gql from '@zenbusiness/application-commons-utils/gql';

export const GET_BANK_CUSTOMER_ADDRESS = gql`
  query bankCustomerAddress($businessEntityUuid: UUID!) {
    bankCustomerAddress(businessEntityUuid: $businessEntityUuid) {
      address1
      address2
      city
      country
      state
      zip
    }
  }
`;

export const GET_BANK_CUSTOMER = gql`
  query bankCustomer($input: BankAccountInput!) {
    bankCustomer(input: $input) {
      id
      status
      merchantAccount {
        dismissedMerchantAccountModal
      }
    }
  }
`;

export const GET_BANK_CUSTOMER_INFO = gql`
  query bankCustomerInfo($input: BankAccountInput!) {
    bankCustomer(input: $input) {
      address {
        street
        city
        country
        state
        postalCode
      }
      contact {
        firstName
        lastName
      }
    }
  }
`;
